/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { ApiParameter, get, HasPagingParameters, ServiceResult } from "@insite/client-framework/Services/ApiService";

export interface TestEmailApiParameter extends ApiParameter, HasPagingParameters {
    email: string;
}

const url = "api/custom/account/validateemail";
const quoteValidateEmailUrl = "api/custom/quote/validateEmail";

export async function testEmailApi(parameter: TestEmailApiParameter): Promise<ServiceResult<any>> {
    try {
        const result = await get<any>(`${url}?email=${parameter.email}`);
        return {
            result,
            successful: true,
        };
    } catch (error) {
        if ("status" in error && error.status === 400 && error.errorJson && error.errorJson.message) {
            return {
                successful: false,
                errorMessage: error?.errorJson?.message,
            };
        }
        throw error;
    }
}

export async function validateQuoteEmailApi(parameter: TestEmailApiParameter): Promise<ServiceResult<any>> {
    try {
        const result = await get<any>(`${quoteValidateEmailUrl}?email=${parameter.email}`);
        return {
            result,
            successful: true,
        };
    } catch (error) {
        if ("status" in error && error.status === 400 && error.errorJson && error.errorJson.message) {
            return {
                successful: false,
                errorMessage: error?.errorJson?.message,
            };
        }
        throw error;
    }
}
